import qs from 'qs';
import { network } from 'services/network';

export const deleteContract = ({ id }) => {
    const querystring = qs.stringify({ id }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/management/deleteContract${querystring}`;
    return network.post(url).then((response) => response.data);
};
